module.exports = __webpack_public_path__ + "static/media/sidenav-back-line.7c1e8b57.png";